import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import config from "../services/config";
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as yup from "yup";
import SubmitButton from '../components/SubmitButton';
import { IoEyeOffOutline, IoEyeOutline } from 'react-icons/io5';
import { FiLock, FiMail } from 'react-icons/fi';
import usePost from '../customHooks/usePost';
import { toast } from 'react-toastify';
import { getTokenSession, setTokenSession } from '../utils/common';

const LogInPage = () => {
  const navigate = useNavigate();
  const [res, apiMethod] = usePost()

  useEffect(() => {
    if(getTokenSession()) {
      navigate(`/${config.demo}`)
    }
  }, [navigate])
  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = yup.object({
    email: yup.string().email("Invalid Email").required("Required"),
    password: yup.string().min(8, "Minimum 8 characters").max(20, "Maximum 20 characters").required("Required")
  });


  const handleSubmit = (values) => {
    let formdata = new FormData();
    for (const item in values) {
      formdata.append(item,values[item])
    }
    apiMethod("login",formdata)
  };
  useEffect(() => {
    if(res.data) {
      const {status,message,data} = res?.data
      if(status === false) {
        toast.error(message);
      }
      else {
        toast.success(message);
        setTokenSession(data?.api_token)
        navigate("/");
      }
    }
  }, [res.data])
  

  const ref = useRef(null);
  const [showPassword, setShowPassword] = useState(false);

  const hidePass = () => {
    if (ref.current) {
      ref.current.type = "password";
      setShowPassword(false);
    }
  };

  const showPass = () => {
    if (ref.current) {
      ref.current.type = "text";
      setShowPassword(true);
    }
  };

  return (
    <main className='loginPage'>
      <section className="loginPage__visual">
        <img src={require("../dist/webImages/loginImage.png")} alt="QuickLease premium rental fleet" />
        <div className="loginPage__overlay">
          <img src={require("../dist/webImages/logo.webp")} className="loginPage__brand" alt="QuickLease" />
          <div><span>Premium mobility management</span><h1>Drive every rental operation from one place.</h1><p>A focused workspace for your fleet, bookings, customers, and content.</p></div>
        </div>
      </section>
      <section className="loginPage__formPanel">
        <div className='loginCard'>
          <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit} validateOnChange>
            <Form>
              <div className='loginCard__mobileLogo'>
                <Link to={`/${config.demo}`}>
                  <img src={require("../dist/webImages/logo.webp")} alt="QuickLease" />
                </Link>
              </div>
              <span className="pageEyebrow">Secure administration</span>
              <h2>Welcome back</h2>
              <p className="loginCard__intro">Sign in with your QuickLease administrator account.</p>
              {res.data?.status === false && <div className="formAlert" role="alert">{res.data.message}</div>}
              <div className='inputBox mb-4'>
                <label htmlFor="login-email">Email address</label>
                <div className="inputWithIcon"><FiMail /><Field id="login-email" name="email" type="email" placeholder='name@company.com' /></div>
                <div className='fieldError'>
                  <ErrorMessage name="email">
                    {(msg) => (
                      <span>{msg}</span>
                    )}
                  </ErrorMessage>
                </div>
              </div>
              <div className='inputBox'>
                <label htmlFor="login-password">Password</label>
                <div className='inputWithIcon'>
                  <FiLock /><Field id="login-password" innerRef={ref} name="password" type="password" placeholder='Enter your password' />
                  <button type="button" className="passwordToggle" aria-label={showPassword ? "Hide password" : "Show password"} onClick={() => !showPassword ? showPass() : hidePass()}>
                    {showPassword ? <IoEyeOffOutline /> : <IoEyeOutline />}
                  </button>
                </div>
                <div className='fieldError'>
                  <ErrorMessage name="password">
                    {(msg) => (
                      <span>{msg}</span>
                    )}
                  </ErrorMessage>
                </div>
              </div>
              {/* <Link className='forget w-full block text-right hover:text-secondary transition-all duration-300'>Forgot Password</Link> */}
              <SubmitButton
                props={{
                  class: "btn primaryButton loginSubmit",
                  text: "Sign In",
                }}
                buttonLoading={res.isLoading}
              />
            </Form>
          </Formik>
        </div>
      </section>
    </main>
  );
};

export default LogInPage;

